import { render } from "./LightBulb.vue?vue&type=template&id=4f7c4a10&scoped=true"
import script from "./LightBulb.vue?vue&type=script&lang=js"
export * from "./LightBulb.vue?vue&type=script&lang=js"

import "./LightBulb.vue?vue&type=style&index=0&id=4f7c4a10&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\SaharSword Web\\LightBulbsExpreiment\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c4a10"]])

export default __exports__